import participant_roles from "dictionaries/participant_roles.json";
import createOptions from "utils/createOptions";

export default createOptions(participant_roles);
